import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=4a6f8d74&"
import script from "./AddNewUser.vue?vue&type=script&lang=js&"
export * from "./AddNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports